import { EMAIL_PATTERN } from '@avanta/shared/constants/patterns';

interface LoginInputs {
  label: string;
  type: string;
  placeholder: string;
  required: boolean;
  showPassword: boolean;
  pattern?: {
    value: RegExp;
  };
  autocomplete?: string;
}

export const loginInputs: Record<string, LoginInputs> = {
  email: {
    label: 'Login.Form.email.label',
    type: 'email',
    placeholder: 'tu@email.com',
    autocomplete: 'username',
    required: true,
    showPassword: false,
    pattern: {
      value: EMAIL_PATTERN,
    },
  },
  password: {
    label: 'Login.Form.password.label',
    type: 'password',
    autocomplete: 'current-password',
    placeholder: '••••••••',
    required: true,
    showPassword: true,
  },
};
